import React, { useEffect, useMemo, useRef, useState } from "react";
import { Select, Table, Tag, DatePicker, Spin } from "antd";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  formatDate,
  getCurrentFormattedDate,
} from "core/Operations/dateFormat";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, PlusCircle } from "react-feather";
import { all_routes } from "Router/all_routes";
import ReportTools from "Components/UI/ReportTools";
import { useEmployeeAdvanceRePaymentList } from "AppQuries/report/get-advance-repayment-report";
import dayjs from "dayjs";
import { format, startOfMonth, endOfMonth } from "date-fns";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { useGetLevyReportQuery } from "AppQuries/report/get-levy-report";
import Error404 from "MainPages/ErrorPages/error404";
import { BackIcon } from "Components/UI/Icon/Icons";
const { RangePicker } = DatePicker;
const EmpLevyReport = () => {
  const userData = useSelector(loggedInUser);
  const [queryParams, setQueryParams] = useState({
    employeeCode: 0,
    month: format(new Date(), "MM"),
    year: format(new Date(), "yyyy"),
  });

  const {
    data: reportData,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetLevyReportQuery({
    month: queryParams.month,
    year: queryParams.year,
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    employeeCode: queryParams.employeeCode || 0,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
    userId: userData?.userID,
  });

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });

  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };
  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueId",
    },
    {
      title: "Emp Name",
      dataIndex: "employeeName",
    },
    {
      title: "Pass Name",
      dataIndex: "passName",
    },
    {
      title: "Levy Type",
      dataIndex: "levyType",
      //   render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Amount",
      dataIndex: "levyAmount",
    },
    {
      title: "Month",
      dataIndex: "month",
    },
    {
      title: "Year",
      dataIndex: "year",
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    reportData,
    searchColumns,
  );

  if (isError) <Error404 error={error} />;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Employee Levy Details</h4>
              <h6>View and download employee levy</h6>
            </div>
          </div>
          <div className="page-btn">
            <ReportTools
              data={reportData}
              columns={columns}
              fileName="Advance Payment Report"
              pdfTheme="plain"
            />
          </div>
          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                to={`${all_routes.report_list}`}
                className="btn btn-secondary"
              >
                <BackIcon className="me-2" />
                Back
              </Link>
            </OverlayTrigger>
          </div>
        </div>
        <div className="card border-0">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <div className="table-list-card">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    showToggle={true}
                    isFilterVisible={isFilterVisible}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label">Month & Year</label>
                              <DatePicker
                                className={`form-control select`}
                                picker="month"
                                onChange={(date) => {
                                  if (date) {
                                    updateQueryParams(
                                      "month",
                                      date.month() + 1,
                                    ); // 🔹 +1 to store as 1–12
                                    updateQueryParams("year", date.year());
                                  } else {
                                    updateQueryParams("month", 0);
                                    updateQueryParams("year", 0);
                                  }
                                }}
                                value={
                                  queryParams.year !== 0 &&
                                  queryParams.month !== 0
                                    ? dayjs(
                                        `${queryParams.year}-${queryParams.month}`,
                                        "YYYY-M",
                                      )
                                    : null
                                }
                                format={"MM-YYYY"}
                                // style={{ width: "150px" }}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <label className="form-label">Employee</label>
                            <Select
                              className="form-control"
                              options={employeeOptions}
                              placeholder="Select Employee"
                              // value={
                              //   employeeOptions.find(
                              //     (option) =>
                              //       option.value === queryParams.employeeCode
                              //   ) || ""
                              // }
                              onChange={(e) => {
                                updateQueryParams("employeeCode", e || 0);
                              }}
                              onClear={(e) => {
                                updateQueryParams("employeeCode", 0);
                              }}
                              allowClear
                              showSearch
                              optionFilterProp="label"
                              variant="borderless"
                            />
                          </div>

                          <div className="col-lg-1 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label className="form-label">&nbsp;</label>
                              <Link
                                className="btn btn-filters ms-auto"
                                onClick={refetch}
                                type="button"
                              >
                                <i
                                  data-feather="search"
                                  className="feather-search"
                                />
                                <>Filter</>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Table
                      loading={isLoading}
                      columns={columns}
                      dataSource={filteredData}
                      rowKey={(record) => record.uniqueID}
                      pagination={true}
                      bordered
                      // scroll={{ x: 1500 }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmpLevyReport;
